import React from "react"
import { useTranslation } from "react-i18next"

import { ActionsOverlay } from "shared/ui/actions-overlay/ActionsOverlay"

import { FilteredFloorActionHandlers } from "features/floor-management/model/useFloorActionHandlers"
import { useFloorActions } from "features/floor-management/model/useFloorActions"

interface FloorActionsOverlayViewProps extends FilteredFloorActionHandlers {
  closeOverlay: () => void
}

export const FloorActionsOverlayView = React.memo(
  ({ closeOverlay, ...handlers }: FloorActionsOverlayViewProps) => {
    const { t } = useTranslation()
    const { actions } = useFloorActions({
      idPrefix: "actions-overlay",
      ...handlers
    })

    return (
      <ActionsOverlay
        id="floor-actions"
        headline={t("Floor.Actions.Actions")}
        actions={actions}
        onCancel={closeOverlay}
      />
    )
  }
)
